// extracted by mini-css-extract-plugin
export default {"wrapper":"confirmation_wrapper__KbPwg","buttons":"confirmation_buttons__-ZuWl","opacity-transition":"confirmation_opacity-transition__PSB05"};